import React, {useEffect, useState} from "react";
import Header from "../../components/Header";
import OrderIdle from "../../components/OrderIdle";
import "./style.scss";
import {useNavigate, useParams} from "react-router";
import FooterForHalfAndHalf from "../../components/FooterForHalfAndHalf";
import {
    getAllSettings,
    getArticlesByCombinationGroup,
    getHalfAndHalfFromSubCategory,
    uniqArray
} from "../../helpers/ApiHelper";
import {useTranslation} from "react-i18next";
import HalfAndHalfArticlesGroup from "../../components/HalfAndHalfArticlesGroup";
import {AdditionalSellUnit, HalfNHalfArticle, MenuItem} from "../../@types/stores/menu";
import menuStore from "../../stores/menu";
import lodash from "lodash";
import {observer} from "mobx-react";
import HalfAndHalfAdditionalSellUnits from "../../components/HalfAndHalfAdditionalSellUnits";


const HalfAndHalfPage = observer(() => {
    const params = useParams()
    const [t] = useTranslation();
    const navigate = useNavigate();

    const [articlesStep, setArticlesStep] = useState<HalfNHalfArticle[]>([]);
    const [selected, setSelected] = useState<(MenuItem | null)[]>([]);
    const [additionalSellUnits, setAdditionalSellUnits] = useState<AdditionalSellUnit[]>([]);
    const [selectedAdditionalSellUnit, setSelectedAdditionalSellUnit] = useState<AdditionalSellUnit | null>(menuStore.selectedAdditionalSellUnitHalfAndHalf);


    useEffect(() => {
        init();
    }, [params.categoryId, params.subCategoryId, menuStore.selectedHalfAndHalfStep]);

    useEffect(() => {
        if (selectedAdditionalSellUnit && articlesStep.length) {
            setArticlesStep(articlesStep.filter(x => x.article.additionalSellUnits?.some(y => y.sellUnitId === selectedAdditionalSellUnit.sellUnitId && y.sellFactor === selectedAdditionalSellUnit.sellFactor)));
        }
    }, [selectedAdditionalSellUnit]);

    const init = async () => {
        if (!menuStore.selectedHalfAndHalfItems[menuStore.selectedHalfAndHalfStep])
            setSelected(selected.filter((x, i) => i !== menuStore.selectedHalfAndHalfStep));

        if (menuStore.selectedHalfAndHalfStep === 2) {
            navigate(`/menu/halfAndHalf/info`);
            return;
        }

        if (!menuStore.menu)
            await menuStore.getMenu();

        if (params.categoryId && params.subCategoryId) {
            menuStore.halfAndHalfNavigation = {
                category: +params.categoryId,
                subCategory: +params.subCategoryId
            };

            if (menuStore.selectedHalfAndHalfItems[menuStore.selectedHalfAndHalfStep]) {
                const menuItem = menuStore.getItemByNumber(menuStore.selectedHalfAndHalfItems[menuStore.selectedHalfAndHalfStep]?.number || "", menuStore.halfAndHalfNavigation.category, menuStore.halfAndHalfNavigation.subCategory);
                if (menuItem) {
                    select(menuStore.selectedHalfAndHalfStep, true, menuItem);
                }
            }

            if (menuStore.selectedHalfAndHalfStep === 0) {
                let menuItem: MenuItem | undefined = undefined;
                let articles = getHalfAndHalfFromSubCategory(menuStore.halfAndHalfNavigation.category, menuStore.halfAndHalfNavigation.subCategory);

                if (getAllSettings()?.disallowHnHInDifferentUnits && articles[0].article.additionalSellUnits && articles[0].article.additionalSellUnits?.length > 1) {
                    setAdditionalSellUnits(uniqArray(articles[0].article.additionalSellUnits, "name"));
                }

                if (selectedAdditionalSellUnit) {
                    articles = articles.filter(x => x.article.additionalSellUnits?.some(y => y.sellUnitId === selectedAdditionalSellUnit.sellUnitId && y.sellFactor === selectedAdditionalSellUnit.sellFactor));
                }

                if (menuStore.selectedHalfAndHalfItems[1]) {
                    menuItem = menuStore.getItemByNumber(menuStore.selectedHalfAndHalfItems[1]?.number || "", menuStore.halfAndHalfNavigation.category, menuStore.halfAndHalfNavigation.subCategory);
                }
                setArticlesStep(menuItem ? articles.filter(x => x.article.number !== menuItem?.number || "") : articles);
            }

            if (menuStore.selectedHalfAndHalfStep === 1) {
                const menuItem = menuStore.getItemByNumber(menuStore.selectedHalfAndHalfItems[0]?.number || "", menuStore.halfAndHalfNavigation.category, menuStore.halfAndHalfNavigation.subCategory);
                if (menuItem?.combinationGroups?.length) {
                    setArticlesStep(getArticlesByCombinationGroup(menuItem.combinationGroups).filter(x => x.article.number !== menuItem.number).filter(x => {
                        if (!selectedAdditionalSellUnit)
                            return true;
                        return x.article.additionalSellUnits?.some(y => y.sellUnitId === selectedAdditionalSellUnit.sellUnitId && y.sellFactor === selectedAdditionalSellUnit.sellFactor)
                    }));
                }
            }
        }
    }

    const select = (step: number, isSelected: boolean, item: MenuItem) => {
        if (!isSelected) {
            menuStore.selectedHalfAndHalfItems[step] = null;
        }

        setSelected(state => {
            const _state = lodash.cloneDeep(state);
            if (step < _state.length)
                _state[step] = isSelected ? item : null;
            else
                _state.push(isSelected ? item : null);

            if (step === 0)
                _state[1] = null;

            return _state;
        });

        goNext();
    }

    const goNext = () => {
        if (menuStore.selectedHalfAndHalfStep === 0 && menuStore.selectedHalfAndHalfItems.filter(x => !!x).length === 2) {
            menuStore.selectedHalfAndHalfStep = 2;
            navigate("/menu/halfAndHalf/info");
            return;
        }

        menuStore.selectedHalfAndHalfStep = menuStore.selectedHalfAndHalfStep + 1;
    }

    const selectAdditionalSellUnit = (item: AdditionalSellUnit | null) => {
        setSelectedAdditionalSellUnit(item);
        menuStore.selectedAdditionalSellUnitHalfAndHalf = item;
    }

    return <div className="HalfAndHalfPage">
        <Header/>
        <div className="content">
            <h2>{t("halfNHalf.title")}</h2>
            <div className="description">{t("halfNHalf.description")}</div>

            {!selectedAdditionalSellUnit && additionalSellUnits.length > 1
                ? <HalfAndHalfAdditionalSellUnits items={additionalSellUnits} selected={selectedAdditionalSellUnit} onSelect={selectAdditionalSellUnit} />
                : <HalfAndHalfArticlesGroup step={menuStore.selectedHalfAndHalfStep} articles={articlesStep} selected={selected[menuStore.selectedHalfAndHalfStep]} onSelect={select} />
            }
        </div>
        <FooterForHalfAndHalf />
        <OrderIdle />
    </div>
});

export default HalfAndHalfPage;
